/**
 * GDSTraceabilityViewTest - GDS追溯模板查看测试页面（统一渲染版）
 * 用于本地开发测试，无需后端即可查看GDS追溯模板效果
 * 访问：http://localhost:3001/?test=gds（?debug=1 显示工具栏）
 */

import React, { useState } from 'react';
import LabelContentRenderer from '../components/label-content';

// Mock数据1：完整示例
const mockData1 = {
  labelName: 'GDS追溯标签 - 有机大米',
  templateType: 'gds-traceability',
  contentData: {
    productName: '五常有机大米',
    productCode: 'GDS-2024-001',
    productionDate: '2024-10-15',
    barcodeValue: '6901234567890',
    carouselImages: [
      'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=800',
      'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=800',
      'https://images.unsplash.com/photo-1536304993881-ff6e9eefa2a6?w=800'
    ],
    tabs: [
      {
        label: '产品信息',
        fields: [
          { label: '产品名称', value: '五常有机大米' },
          { label: '规格型号', value: '5kg/袋' },
          { label: '保质期', value: '12个月' },
          { label: '储存条件', value: '阴凉干燥处' },
          { label: '产地', value: '黑龙江省五常市' },
          { label: '品种', value: '稻花香2号' }
        ]
      },
      {
        label: '生产信息',
        fields: [
          { label: '生产企业', value: '五常市XX米业有限公司' },
          { label: '生产地址', value: '黑龙江省五常市工业园区' },
          { label: '生产日期', value: '2024-10-15' },
          { label: '生产批次', value: 'WC202410150001' },
          { label: '生产许可证', value: 'SC12345678901234567' },
          { label: '联系电话', value: '029-81330339' }
        ]
      },
      {
        label: '质检信息',
        fields: [
          { label: '检验报告编号', value: 'JY-2024-10-15-001' },
          { label: '检验日期', value: '2024-10-14' },
          { label: '检验机构', value: '国家食品质量监督检验中心' },
          { label: '检验结果', value: '合格' },
          { label: '农药残留', value: '未检出' },
          { label: '重金属', value: '符合国家标准' }
        ]
      }
    ],
    certifications: [
      {
        type: 'gi',
        label: 'GI地理标志',
        certified: true,
        certNumber: 'GI-2024-001',
        certDate: '2024-01-10',
        certOrg: '国家知识产权局'
      },
      {
        type: 'organic',
        label: '有机认证',
        certified: true,
        certNumber: 'YJ-2024-002',
        certDate: '2024-02-15',
        certOrg: '中国有机认证中心'
      },
      {
        type: 'green',
        label: '绿色食品',
        certified: true,
        certNumber: 'LV-2024-003',
        certDate: '2024-03-20',
        certOrg: '中国绿色食品发展中心'
      }
    ]
  }
};

// Mock数据2：简单示例
const mockData2 = {
  labelName: 'GDS追溯标签 - 山茶油',
  templateType: 'gds-traceability',
  contentData: {
    productName: '野生山茶油',
    productCode: 'GDS-2024-002',
    productionDate: '2024-11-01',
    barcodeValue: '6901234567891',
    carouselImages: [
      'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=800'
    ],
    tabs: [
      {
        label: '产品信息',
        fields: [
          { label: '产品名称', value: '野生山茶油' },
          { label: '规格型号', value: '500ml/瓶' },
          { label: '保质期', value: '18个月' },
          { label: '储存条件', value: '避光密封保存' }
        ]
      },
      {
        label: '生产信息',
        fields: [
          { label: '生产企业', value: 'XX山茶油有限公司' },
          { label: '生产地址', value: '江西省XX县' },
          { label: '生产日期', value: '2024-11-01' },
          { label: '生产批次', value: 'SC202411010001' }
        ]
      }
    ],
    certifications: [
      {
        type: 'gi',
        label: 'GI地理标志',
        certified: true,
        certNumber: 'GI-2024-005',
        certDate: '2024-05-10',
        certOrg: '国家知识产权局'
      }
    ]
  }
};

function GDSTraceabilityViewTest() {
  const [currentMock, setCurrentMock] = useState(1);
  const labelData = currentMock === 1 ? mockData1 : mockData2;
  const data = labelData.contentData;

  return (
    <div style={{ maxWidth: 960, margin: '0 auto', padding: 20 }}>
      {/* 测试工具栏（仅 ?debug=1 显示） */}
      {window.location.search.includes('debug=1') && (
        <div style={{
          position: 'fixed', top: 10, right: 10, zIndex: 9999,
          background: 'var(--color-bg-base)', padding: 10, borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)', border: '1px solid var(--color-border-light)'
        }}>
          <div style={{ fontSize: 12, marginBottom: 8, fontWeight: 600 }}>测试模式</div>
          <button
            onClick={() => setCurrentMock(1)}
            style={{
              padding: '6px 12px', marginRight: 8,
              background: currentMock === 1 ? 'var(--color-primary)' : 'var(--color-bg-base)',
              color: currentMock === 1 ? 'var(--color-text-inverse)' : 'var(--color-text-primary)',
              border: '1px solid var(--color-border-light)', borderRadius: 4, cursor: 'pointer', fontSize: 12
            }}
          >完整示例</button>
          <button
            onClick={() => setCurrentMock(2)}
            style={{
              padding: '6px 12px',
              background: currentMock === 2 ? 'var(--color-primary)' : 'var(--color-bg-base)',
              color: currentMock === 2 ? 'var(--color-text-inverse)' : 'var(--color-text-primary)',
              border: '1px solid var(--color-border-light)', borderRadius: 4, cursor: 'pointer', fontSize: 12
            }}
          >简单示例</button>
        </div>
      )}

      {/* 使用统一渲染器展示GDS追溯模板 */}
      <LabelContentRenderer item={{ type: 'gds-traceability', data }} mode="view" />

      {/* 说明信息 */}
      <div style={{ marginTop: 24, fontSize: 12, color: 'var(--color-text-secondary)', textAlign: 'center' }}>
        本页面用于本地测试。实际对外展示请使用 “/view/:labelId” 链接。
      </div>
    </div>
  );
}

export default GDSTraceabilityViewTest;
